import React from "react";
import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import { site } from "../mock";
import { useContent } from "../context/ContentContext";

const links = [
  { label: "About", href: "/#about" },
  { label: "Services", href: "/#services" },
  { label: "Pricing", href: "/#pricing" },
  { label: "Team", href: "/#team" },
  { label: "Before & After", href: "/before-after", route: true },
  { label: "Locations", href: "/#locations" },
  { label: "Contact", href: "/#contact" },
];

export default function Footer() {
  const { content } = useContent();
  const { instagram, bookUrl, tagline, locationsBanner } = content.settings;

  return (
    <footer className="bg-[#0C0C0C] text-[#9E988B] pt-16 pb-8 px-6 border-t border-[#1c1c1c]">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-10">
          <div className="flex items-center gap-4">
            <img src={site.logo} alt="Skinplicity" className="w-14 h-14" />
            <div>
              <div className="font-serif-display text-2xl text-[#C6A15B] leading-none">
                {site.name}
              </div>
              <div className="text-[11px] tracking-[0.18em] uppercase mt-2">{tagline}</div>
            </div>
          </div>

          <nav className="flex flex-wrap gap-x-6 gap-y-3 max-w-md">
            {links.map((l) =>
              l.route ? (
                <Link key={l.href} to={l.href} className="text-xs tracking-[0.18em] uppercase hover:text-[#C6A15B] transition-colors">
                  {l.label}
                </Link>
              ) : (
                <a key={l.href} href={l.href} className="text-xs tracking-[0.18em] uppercase hover:text-[#C6A15B] transition-colors">
                  {l.label}
                </a>
              )
            )}
          </nav>

          <div className="flex items-center gap-4 self-start">
            <a
              href={instagram}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="h-11 w-11 border border-[#C6A15B]/50 flex items-center justify-center text-[#C6A15B] hover:bg-[#C6A15B] hover:text-[#0C0C0C] transition-colors"
            >
              <Instagram size={18} />
            </a>
            <a
              href={bookUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="border border-[#C6A15B] text-[#C6A15B] text-xs tracking-[0.2em] uppercase px-7 py-3 hover:bg-[#C6A15B] hover:text-[#0C0C0C] transition-colors"
            >
              Book Now
            </a>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-[#1c1c1c] flex flex-col sm:flex-row justify-between gap-3 text-[11px] tracking-[0.12em] uppercase">
          <span>© {new Date().getFullYear()} Skinplicity Wellness. All rights reserved.</span>
          <div className="flex items-center gap-4">
            <span>{(locationsBanner || []).join("  \u00b7  ")}</span>
            <Link to="/admin" className="text-[#6b6b6b] hover:text-[#C6A15B] transition-colors">
              Admin
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
